import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import NavFacets from './nav-facets'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import ProductCard from './product-card'

const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 20,
    marginBottom: 24,
    '& :last-child':{
        gridRow: 3
    },
}

const viewAllStyle = theme => css({
    fontFamily: theme.fonts.secondary,
    fontWeight: 700,
    '@media(min-width: 1025px)':{
        marginTop: 8,
    }
})

const dividerStyle = theme => css({ 
    marginTop: 24,
    paddingTop: 24,
    borderTop: `1px solid ${theme.colors.mutedDark}`,
})

const productGridStyle = {
    display: 'grid', 
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 20,
}

export const Links = (props) => {
    const { viewAllNumber} = props
    return(
        <>
            <Link to='/synthesizers/muse' {...props}>Muse</Link>
            <Link to='/synthesizers/minimoog-model-d' {...props}>Minimoog Model D</Link>
            <Link to='/synthesizers/mother-32' {...props}>Mother-32</Link>
            <Link to='/synthesizers/matriarch' {...props}>Matriarch</Link>
            <Link to='/synthesizers/labyrinth' {...props}>Labyrinth</Link>
            <Link to='/synthesizers/subharmonicon' {...props}>Subharmonicon</Link>
            <Link to='/synthesizers/subsequent-37' {...props}>Subsequent 37</Link>
            <Link to='/synthesizers' css={viewAllStyle} {...props}>View All Synthesizers ({viewAllNumber})</Link>
        </>
    )
}

export default function NavSynthesizers() {
    const rootPath = 'Synthesizers'
    const products = useGetAllBuilderProducts()
    const categoryProducts = products.filter(({ data }) => data.categories.lvl0 === rootPath)
    const featuredProducts = categoryProducts.filter(({ data }) => data.featured)
        
    return <>
        <div css={gridStyle}><Links viewAllNumber={categoryProducts.length} /></div>
        <NavFacets rootPath={rootPath} />
        <h4 css={[dividerStyle, { marginBottom: 20 }]}>Featured Products</h4>
        <div css={productGridStyle}>
            {featuredProducts.slice(0, 4).map((product, i) => <ProductCard key={`${product.objectID}-${i}`} product={product} />)}
        </div>
    </>
}
